import {Pipe, PipeTransform} from '@angular/core';

const _imr = /(i'm r)/ig;

@Pipe({
	standalone: false,
	name: 'imr',
})
export class ImrPipe implements PipeTransform {
	transform(value: string): string {
		return value.replace(_imr, '<em>$1</em>');
	}
}